const toggler = () => {

    $('.available-toggler').click(e => {
        if ($('.available-toggler').children('span').hasClass('available-toggle-button-on')) {
            $('.available-toggler').children('span').addClass('available-toggle-button-off');
            $('.available-toggler').children('span').removeClass('available-toggle-button-on');
        } else {
            $('.available-toggler').children('span').addClass('available-toggle-button-on');
            $('.available-toggler').children('span').removeClass('available-toggle-button-off');
        }
        
    })
        
};

export {
    toggler
};
